<template>
  <div class="home">
  <Homehero
    >
      
      <Herocard>
        <Herovalueproposition>
          Your favorite meals, delivered by Restaurium
        </Herovalueproposition>
        <Herosearch :autofocus="false"/>
      </Herocard>
      <br>
        <div height="30vh">
        <v-img
          max-height="30vh"
          contain
          class="d-flex"
          src="@/assets/undraw_Hamburger_8ge6.svg"
        />
        </div>
     
    </Homehero>
   
  </div>
</template>

<script>
// @ is an alias to /src
import Homehero from '@/components/Homehero.vue'
import Herocard from '@/components/Herocard.vue'
import Herovalueproposition from '@/components/Herovalueproposition.vue'
import Herosearch from '@/components/Herosearch.vue'


export default {
  name: 'Home',
  components: {
    Homehero,
    Herocard,
    Herovalueproposition,
    Herosearch,

  }
}
</script>
